<template>
    <BaseElement v-model="value" :edit="edit" :create="create" :element="'td'">
    </BaseElement>
</template>

<script>
import { defineAsyncComponent } from 'vue';
const Structure = defineAsyncComponent(() => import('@/components/Structure.vue'));
import BaseElement from '@/components/calculations/BaseElement.vue';

export default {
    components: {
        Structure,
        BaseElement
    },
    props: {
        modelValue: {},
        edit: {
            type: Boolean,
            required: false,
            default: false
        },
        create: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        show: function () {
            return this.value && !this.value.hide;
        }
    }
}
</script>
<style lang="scss">
</style>